export function formatUserName(user: {
    givenName?: string;
    familyName?: string;
  }) {

    if (!user) { return 'Unknown User'; }

    const names = [ user.givenName, user.familyName ].filter(Boolean);
    return names.join(' ');
}

export function firstInitialLastName(user: {givenName?: string; familyName?: string}){
  if (!user) { return 'Unknown User'; }

  // CR e6d5021a: a customer user can be truthy without a givenName —
  // substring(0, 1) on undefined threw before the completed batch rendered.
  // Fall back to the family name alone, then to the blank-user label.
  const firstInitial = (user.givenName ?? '').substring(0, 1).toUpperCase();

  if (!firstInitial) { return user.familyName || 'Unknown User'; }

  return `${firstInitial}. ${user.familyName}`;
}

export function lastNameFirstName(user: {givenName?: string; familyName?: string}) {
  return `${user.familyName}, ${user.givenName}`;
}
